import axios from "axios";
import { domain } from "../Constants";

const tag = {

    getAllTags() {
        return axios({
            url: `${domain}api/tag`,
            method: "GET"
        }).catch(e => {
            console.log('Catch error on get all tag\n', e.message);
            return { status: e.response.status }
        });
    },

    addNewTag(data) {
        return axios({
            url: `${domain}api/tag`,
            method: "POST",
            data: { name: data.name, type: parseInt(data.type) }
        }).catch(e => {
            console.log('Catch error on add new tag\n', e.message);
            return { status: e.response.status }
        });
    },

    taggingPortfolio(data) {
        let param = { portfolio_id: data.portfolio_id, tags: [ ...data.tags, ...data.awardTags ] };
        return axios({
            url: `${domain}api/tagport`,
            method: "POST",
            data: param
        }).catch(e => {
            console.log('Catch error on tagging portfolio\n', e.message);
            return { status: e.response.status }
        });
    },

    getTagPortfolio(id) {
        return axios({
            url: `${domain}api/tagport/${id}`,
            method: "GET"
        }).catch(e => {
            console.log('Catch error on get portfolio tag\n', e.message);
            return { status: e.response.status }
        });
    }

};

export default tag;
